module.exports = __webpack_public_path__ + "img/connect-apps.8309132d.svg";